"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ArrowDownSmall;
var _ArrowDownSmall = require("@adobe/react-spectrum-ui/dist/ArrowDownSmall.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function ArrowDownSmall(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ArrowDownSmall.ArrowDownSmall, null));
}